import { useCallback } from 'react';
import type React from 'react';

import type { WaypointCallbackArgs } from '#src/app/shared/components/layout/lazy';
import { Waypoint } from '#src/app/shared/components/scroll';

// FIXME move this file to page's shared/hooks folder
// eslint-disable-next-line @change/sibling-module-imports
import { usePageScrollPosition } from '../../hooks/scroll';

export const InsideEmbeddedSignFormWaypoint: React.FC<{
	onEnter: () => void;
}> = ({ onEnter }) => {
	const { setInsideEmbeddedSignForm } = usePageScrollPosition();

	const onPositionChange = useCallback(
		({ currentPosition }: WaypointCallbackArgs) => setInsideEmbeddedSignForm(currentPosition === 'inside'),
		[setInsideEmbeddedSignForm],
	);

	// using onPositionChange so that it is triggered at hydration
	return <Waypoint onPositionChange={onPositionChange} onEnter={onEnter} />;
};
